export var BidAmountDetail={properties:{Amount:{'bulk-upload-header':'Bid'}}};